import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    name: "PtIcon",
    inheritAttrs: false,
    props: {
        /**
     * @description SVG icon size, size x size
     */ size: {
            type: definePropType([
                Number
            ])
        },
        /**
     * @description SVG tag's fill attribute
     */ color: {
            type: String
        }
    },
    setup: function setup(props) {
        var style = computed(function() {
            var size = props.size, color = props.color;
            if (!size && !color) return {};
            return {
                fontSize: size === undefined ? undefined : "".concat(size, "px"),
                "--color": color
            };
        });
        return {
            style: style
        };
    }
});
